import OwnerShipDetails from "./OwnerShipDetails";

export default OwnerShipDetails;
